import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import StatusLabel from '../../shared/components/StatusLabel';
import FormattedListValue from '@/shared/components/FormattedListValue';
import { listItemMsg } from '@/shared/components/FormattedListValue';

const RecognitionStatus = ({ status, iconOnly = false }) => {
  const intl = useIntl();
  let statuses = [];

  let recognitionStatus = status;
  // Show 'not applicable' as 'processed' for now
  if (status === 0) {
    recognitionStatus = 4;
  }

  // Recognizing
  if (recognitionStatus === 1) {
    statuses = ['info', 'active'];
  }

  // Recognized
  if (recognitionStatus === 2) {
    statuses = ['info'];
  }

  // Processing
  if (recognitionStatus === 3) {
    statuses = ['info', 'active'];
  }

  // Processed/not applicable
  if (recognitionStatus === 4) {
    statuses = ['success'];
  }

  // Unrecognized
  if (recognitionStatus === 5) {
    statuses = ['warning'];
  }
  const statusLabel = intl.formatMessage(listItemMsg('recognitionstatus', recognitionStatus));

  return (
    <StatusLabel statuses={statuses} className="document-status-label" title={statusLabel}>
      {!iconOnly ? <span className="hidden-xs hidden-sm">{statusLabel}</span> : ' '}
    </StatusLabel>
  );
};

RecognitionStatus.propTypes = {
  status: PropTypes.number.isRequired,
};

export default RecognitionStatus;
